import {
  isValidCircuit,
  isValidCountry,
  isValidDistrict,
  isValidDistrictMunicipality,
  isValidEcdServiceType,
  isValidEducationSector,
  isValidEmis,
  isValidFundingClass,
  isValidGender,
  isValidGrade,
  isValidInstitutionName,
  isValidInstitutionTrackingCode,
  isValidLanguage,
  isValidLocalMunicipality,
  isValidNewOrRenewalValue,
  isValidPeopleId,
  isValidPopulationGroup,
  isValidProvince,
  isValidRegion,
  isValidRegistrationStatus,
  isValidSchoolPhase,
  isValidSchoolSpecializationGroup,
  isValidSchoolType,
  // isValidType,
  isValidVerifiedValue,
  isValidReasonForExit,
  isValidSubjectCode,
  isValidDate,
  isValidNearestPointOfInterest,
  isValidYear,
  isValidFoodProvider,
  // isValidRegistrationOffice,
} from '.';
import {
  isValidDateFormat,
  isValidRegistrationInstitution,
  isValidTypeAndOperation,
  isValidUploadDateFormat,
} from './validator';

export const flatfilePeopleValidator = async (record: any, updateOrNew?: string) => {
  let out: any = {};

  if (record.id) {
    const valid = await isValidPeopleId(record.id);
    if (!valid) {
      out.id = {
        info: [
          {
            message: 'Must be valid people ID',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.institution) {
    const valid = (await isValidInstitutionName(record.institution)) || record.trackingCode;
    if (!valid) {
      out.institution = {
        info: [
          {
            message: 'Must be valid institution name',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.primaryInstitution) {
    const valid = await isValidEmis(record.primaryInstitution);
    if (!valid) {
      out.primaryInstitution = {
        info: [
          {
            message: 'Must be valid emis number',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.emisNumber) {
    const valid = await isValidEmis(record.emisNumber);
    if (!valid) {
      out.emisNumber = {
        info: [
          {
            message: 'Must be valid emis number',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.grade) {
    if (record.multiGrade) {
      var gradeArr = record.grade.split('/');
      for (let item in gradeArr) {
        const valid = await isValidGrade(gradeArr[item]);
        if (!valid) {
          out.grade = {
            info: [
              {
                message: 'Must be valid grade (' + gradeArr[item] + '). Multiple grades must be split by /',
                level: 'error',
              },
            ],
          };
        }
      }
    } else {
      const valid = await isValidGrade(record.grade);
      if (!valid) {
        out.grade = {
          info: [
            {
              message: 'Must be valid grade',
              level: 'error',
            },
          ],
        };
      }
    }
  }

  if (record.type) {
    const errorMessge = await isValidTypeAndOperation(record, updateOrNew);
    if (errorMessge) {
      out.type = {
        info: [
          {
            message: errorMessge,
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.gender) {
    const valid = await isValidGender(record.gender);
    if (!valid) {
      out.gender = {
        info: [
          {
            message: 'Must be valid Gender',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.dateOfBirth) {
    const valid = await isValidDateFormat(record.dateOfBirth);
    if (!valid) {
      out.dateOfBirth = {
        info: [
          {
            message: 'Must be valid date of birth (ccyy/mm/dd)',
            level: 'error',
          },
        ],
      };
    }
  }
  if (record.dateExited) {
    const valid = await isValidDateFormat(record.dateExited);
    if (!valid) {
      out.dateExited = {
        info: [
          {
            message: 'Must be valid date of birth (ccyy/mm/dd)',
            level: 'error',
          },
        ],
      };
    }
  }
  if (record.dateStarted) {
    const valid = await isValidDateFormat(record.dateStarted);
    if (!valid) {
      out.dateStarted = {
        info: [
          {
            message: 'Must be valid date of birth (ccyy/mm/dd)',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.populationGroup) {
    const valid = await isValidPopulationGroup(record.populationGroup);
    if (!valid) {
      out.populationGroup = {
        info: [
          {
            message: 'Must be valid Population Group',
            level: 'error',
          },
        ],
      };
    }
  }
  if (!record.type) {
    out.termination = {
      info: [
        {
          message: 'Must be present',
          level: 'error',
        },
      ],
    };
  }

  if (!record.firstName) {
    out.termination = {
      info: [
        {
          message: 'Must be present',
          level: 'error',
        },
      ],
    };
  }

  if (record.homeLanguage) {
    const valid = await isValidLanguage(record.homeLanguage);
    if (!valid) {
      out.homeLanguage = {
        info: [
          {
            message: 'Must be valid Home Language',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.subject) {
    var subjectArr = record.subject.split('/');
    for (let item in subjectArr) {
      const valid = await isValidSubjectCode(subjectArr[item]);
      if (!valid) {
        out.subject = {
          info: [
            {
              message: 'Must be valid subject code (' + subjectArr[item] + '). Multiple subjects must be split by /',
              level: 'error',
            },
          ],
        };
      }
    }
  }

  if (record.termination) {
    const valid = await isValidReasonForExit(record.termination);
    if (!valid) {
      out.termination = {
        info: [
          {
            message: 'Must be valid reason for exit',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.additionalInstitution) {
    var instArr = record.additionalInstitution.split('/');
    for (let item in instArr) {
      const valid = await isValidEmis(instArr[item]);
      if (!valid) {
        out.additionalInstitution = {
          info: [
            {
              message: 'Must be valid emis number (' + instArr[item] + '). Multiple institutions must be split by /',
              level: 'error',
            },
          ],
        };
      }
    }
  }
  return out;
};

export const flatfileMonitoringFormValidator = async (record: any) => {
  let out: any = {};

  if (record.periodDate) {
    const valid = isValidUploadDateFormat(record.periodDate);
    if (!valid) {
      out.periodDate = {
        info: [
          {
            message: 'Must be a valid date (yyyy-mm-dd or dd-mm-yyyy)',
            level: 'error',
          },
        ],
      };
    }
  }

  return out;
};

export const flatfileRegistrationValidator = async (record: any, updateOrNew: string) => {
  let out: any = {};

  if (record.institution) {
    const errorMessge = await isValidRegistrationInstitution(record.institution, updateOrNew);

    if (errorMessge) {
      out.institution = {
        info: [
          {
            message: errorMessge,
            level: 'error',
          },
        ],
      };
    }
  }

  return out;
};

export const flatfileInstitutionValidator = async (record: any) => {
  let out: any = {};

  if (record.trackingCode) {
    const valid = await isValidInstitutionTrackingCode(record.trackingCode);
    if (!valid) {
      out.trackingCode = {
        info: [
          {
            message: 'This value already exists for another institution',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.sector) {
    const valid = await isValidEducationSector(record.sector);
    if (!valid) {
      out.sector = {
        info: [
          {
            message: 'Must be valid education sector',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.ecdServiceType) {
    const valid = await isValidEcdServiceType(record.ecdServiceType);
    if (!valid) {
      out.ecdServiceType = {
        info: [
          {
            message: 'Must be valid ECD Service type',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.schoolType) {
    const valid = await isValidSchoolType(record.schoolType);
    if (!valid) {
      out.schoolType = {
        info: [
          {
            message: 'Must be valid school type',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.phase) {
    const valid = await isValidSchoolPhase(record.phase);
    if (!valid) {
      out.phase = {
        info: [
          {
            message: 'Must be valid school phase',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.specializationGroup) {
    const valid = await isValidSchoolSpecializationGroup(record.specializationGroup);
    if (!valid) {
      out.specializationGroup = {
        info: [
          {
            message: 'Must be valid specialization group',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.country) {
    const valid = await isValidCountry(record.country);
    if (!valid) {
      out.country = {
        info: [
          {
            message: 'Must be valid country name',
            level: 'error',
          },
        ],
      };
    }
  }

  if (!record.country && !record.emisNumber && !record.trackingCode && !record.id && !record.censusID) {
    out.country = {
      info: [
        {
          message: 'Country is required',
          level: 'error',
        },
      ],
    };
  }

  if (record.province) {
    const valid = await isValidProvince(record.province);
    if (!valid) {
      out.province = {
        info: [
          {
            message: 'Must be valid province name',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.region) {
    const valid = await isValidRegion(record.region);
    if (!valid) {
      out.region = {
        info: [
          {
            message: 'Must be valid region name',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.district) {
    const valid = await isValidDistrict(record.district);
    if (!valid) {
      out.district = {
        info: [
          {
            message: 'Must be valid district name',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.circuit) {
    const valid = await isValidCircuit(record.circuit);
    if (!valid) {
      out.circuit = {
        info: [
          {
            message: 'Must be valid circuit',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.districtMunicipality) {
    const valid = await isValidDistrictMunicipality(record.districtMunicipality);
    if (!valid) {
      out.districtMunicipality = {
        info: [
          {
            message: 'Must be valid district municipality',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.localMunicipality) {
    const valid = await isValidLocalMunicipality(record.localMunicipality);
    if (!valid) {
      out.localMunicipality = {
        info: [
          {
            message: 'Must be valid local municipality',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.fundingClassification) {
    const valid = await isValidFundingClass(record.fundingClassification);
    if (!valid) {
      out.fundingClassification = {
        info: [
          {
            message: 'Must be valid funding classification',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.newOrRenewal) {
    const valid = await isValidNewOrRenewalValue(record.newOrRenewal);
    if (!valid) {
      out.newOrRenewal = {
        info: [
          {
            message: 'Must be valid value for new or renewal',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.nearestPointOfInterest) {
    const valid = await isValidNearestPointOfInterest(record.nearestPointOfInterest);
    if (!valid) {
      out.nearestPointOfInterest = {
        info: [
          {
            message: 'Must be valid value for new or renewal',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.registrationStatus) {
    const valid = await isValidRegistrationStatus(record.registrationStatus);
    if (!valid) {
      out.registrationStatus = {
        info: [
          {
            message: 'Must be valid registration status',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.verified) {
    const valid = await isValidVerifiedValue(record.verified);
    if (!valid) {
      out.verified = {
        info: [
          {
            message: 'Must be valid value for verified',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.validated) {
    const valid = await isValidVerifiedValue(record.validated);
    if (!valid) {
      out.validated = {
        info: [
          {
            message: 'Must be valid value for validated',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.issueDate) {
    const valid = await isValidDate(record.issueDate);
    if (!valid) {
      out.issueDate = {
        info: [
          {
            message: 'Must be a valid date',
            level: 'error',
          },
        ],
      };
    }
  }
  if (record.expiryDate) {
    const valid = await isValidDate(record.expiryDate);
    if (!valid) {
      out.expiryDate = {
        info: [
          {
            message: 'Must be a valid date',
            level: 'error',
          },
        ],
      };
    }
  }
  if (record.progCertificateIssueDate) {
    const valid = await isValidDate(record.progCertificateIssueDate);
    if (!valid) {
      out.progCertificateIssueDate = {
        info: [
          {
            message: 'Must be a valid date',
            level: 'error',
          },
        ],
      };
    }
  }
  if (record.progCertificateExpiryDate) {
    const valid = await isValidDate(record.progCertificateExpiryDate);
    if (!valid) {
      out.progCertificateExpiryDate = {
        info: [
          {
            message: 'Must be a valid date',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.progStatus) {
    const valid = await isValidRegistrationStatus(record.progStatus);
    if (!valid) {
      out.progStatus = {
        info: [
          {
            message: 'Must be a valid prog status',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.foodProvider) {
    const valid = await isValidFoodProvider(record.foodProvider);
    if (!valid) {
      out.foodProvider = {
        info: [
          {
            message: 'Must be valid food providers only',
            level: 'error',
          },
        ],
      };
    }
  }

  // if (record.registrationOffice) {
  //   const valid = await isValidRegistrationOffice(record.registrationOffice);
  //   if (!valid) {
  //     out.registrationOffice = {
  //       info: [
  //         {
  //           message: 'Must be valid registration offices only',
  //           level: 'error',
  //         },
  //       ],
  //     };
  //   }
  // }

  if (record.yearEcdStartedOperating) {
    const valid = await isValidYear(record.yearEcdStartedOperating);
    if (!valid) {
      out.yearEcdStartedOperating = {
        info: [
          {
            message: 'Must be valid a year',
            level: 'error',
          },
        ],
      };
    }
  }

  if (record.yearOfReceipt) {
    const valid = await isValidYear(record.yearOfReceipt);
    if (!valid) {
      out.yearOfReceipt = {
        info: [
          {
            message: 'Must be valid a year',
            level: 'error',
          },
        ],
      };
    }
  }

  if (!record.name && !record.emisNumber && !record.trackingCode && !record.id && !record.censusID) {
    out.name = {
      info: [
        {
          message: 'Name is required',
          level: 'error',
        },
      ],
    };
  }

  return out;
};
